// src/hooks/useAuthCheck.js
import { useEffect } from "react";
import { useNavigate } from "react-router-dom";

export default function useAuthCheck() {
  const navigate = useNavigate();

  useEffect(() => {
    const token = localStorage.getItem("access_token");

    // Only redirect if there is NO token at all
    if (!token) {
      navigate("/Login");
    }

    // ✅ Do NOT check expiration here; let axios interceptor handle refresh
  }, [navigate]);
}
